<template>
  <div>
    <template v-if="facility.hasFunding">
      <facility-schedule :facility="facility" />
      <facility-daily-interest :facility="facility" />
      <facility-monthly-interest :facility="facility" />
      <facility-yearly-interest :facility="facility" />
    </template>
    <template v-else>
      <p class="text-center py-3">
        No facility has been created yet.
      </p>
    </template>
  </div>
</template>

<script>
import FacilityDailyInterest from './FacilityDailyInterest.vue'
import FacilityMonthlyInterest from './FacilityMonthlyInterest.vue'
import FacilitySchedule from './FacilitySchedule.vue'
import FacilityYearlyInterest from './FacilityYearlyInterest.vue'

export default {
  name: 'ProjectLoan',

  components: {
    FacilityDailyInterest,
    FacilityMonthlyInterest,
    FacilitySchedule,
    FacilityYearlyInterest
  },

  props: {
    facility: Object
  }
}
</script>
